<template>
  <div class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <!-- 画像一覧を表示-->
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>コメント</h2>
      </div>
      <div class="data-area">
        <div class="comment">{{ comment }}</div>
      </div>
      <div class="modal-footer">
        <button class="main_btn" @click="close()">閉じる</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SketchComment',
  data () {
    return {
      modalShown: false,
      comment: ''
    }
  },
  watch: {
  },
  methods: {
    showModal: function (comment) {
      this.comment = comment
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    }
  }
}
</script>
<style lang="scss" scoped>
.data-area{
  padding: 20px;
}
.comment{
  font-size: 20px;
  width: 100%;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/SketchComment.vue